import { ImageWrapper } from '../wrappers/ImageWrapper';
import logo from '../../../assets/images/common/logo.webp';

export default function HomeLogo() {
    return (
        <div className="home-logo">
            <ImageWrapper src={logo} alt="logo" />
        </div>
    );
}
